import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-card__compatibility"
}
const _hoisted_2 = {
  key: 1,
  class: "product-card__img-wrapper"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "product-card__img-fallback"
}
const _hoisted_5 = { class: "product-card__text-wrapper" }

import { computed, ref, onMounted } from 'vue';
import IconTooltip from './shared/IconTooltip.vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {Tippy} from "vue-tippy";

export default /*#__PURE__*/_defineComponent({
  props: {
    id: String,
    displayName: String,
    description: String,
    imageUrl: String,
    route: String,
    isSelected: Boolean,
    isDisabled: Boolean,
    categoryType: String,
    subcategoryType: String,
    fieldId: String,
    compatibilityMessage: String,
    compatibilityModalMessage: String,
},
  emits: ['update-route', 'update-selection'],
  setup(__props, { emit }) {

const props = __props



const hideOnScrollRef = ref(null);
function handleClick() {
    emit('update-selection', { selection: props, fieldId: props.fieldId });
}

const transparentImageUrl = computed(() => {
    return `${props.imageUrl}&fmt=png-alpha&wid=168`;
});

function onTippyShow(instance) {
	// Define the event listener to hide the tooltip on scroll/wheel
	const hideOnScroll = () => {
		instance.hide()
	}
	hideOnScrollRef.value = hideOnScroll

	// Add event listeners for scroll and wheel events
	window.addEventListener('wheel', hideOnScroll, { passive: true })
	window.addEventListener('scroll', hideOnScroll, { passive: true })
}

function onTippyHide() {
	// Remove the event listeners when the tooltip hides
	if (hideOnScrollRef.value) {
		window.removeEventListener('wheel', hideOnScrollRef.value)
		window.removeEventListener('scroll', hideOnScrollRef.value)
		hideOnScrollRef.value = null
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card__wrapper", { 'product-card__isSelected': __props.isSelected }]),
    onClick: handleClick
  }, [
    (!!__props.compatibilityMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Tippy), {
            content: __props.compatibilityMessage,
            "allow-html": true,
            onShow: onTippyShow,
            onHide: onTippyHide
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FontAwesomeIcon), {
                class: "icon-tooltip-icon",
                icon: "fa-solid fa-triangle-exclamation"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["content"])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.imageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "product-card__img",
            src: _unref(transparentImageUrl)
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: ['fa-thin', 'fa-circle-quarters'],
            class: "product-card__img-fallback-icon"
          })
        ])),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", {
        class: _normalizeClass(["product-card__title", { isSelected: __props.isSelected }])
      }, _toDisplayString(__props.displayName), 3 /* TEXT, CLASS */)
    ])
  ], 2 /* CLASS */))
}
}

})